import { render, staticRenderFns } from "./RelatorioSortimento.vue?vue&type=template&id=e25e2ce0"
import script from "./RelatorioSortimento.vue?vue&type=script&lang=js"
export * from "./RelatorioSortimento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports